import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const documentApi = axios.create({
  baseURL: `${API_BASE_URL}/documents`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
documentApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
documentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const documentService = {
  getByEmployeeId: (employeeId) => documentApi.get(`/employee/${employeeId}`),

  upload: async (employeeId, file, description) => {
    const formData = new FormData();
    formData.append('file', file);
    if (description) {
      formData.append('description', description);
    }

    const token = authService.getToken();
    const response = await axios.post(
      `${API_BASE_URL}/documents/employee/${employeeId}`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  download: async (documentId) => {
    const token = authService.getToken();
    const response = await axios.get(
      `${API_BASE_URL}/documents/${documentId}/download`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );
    return response.data;
  },

  delete: (documentId) => documentApi.delete(`/${documentId}`),
};

export default documentService;

